'use client';

var EMPTY_COMPANY_IMAGE = "img/company-default-logo.svg";
var EMPTY_BANNER_IMAGE = "company-assets/images/banner-default-company.png";

export { EMPTY_BANNER_IMAGE, EMPTY_COMPANY_IMAGE };
//# sourceMappingURL=const.js.map
